import { sendPlausibleEvent } from '@/lib/track';

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;

  sendPlausibleEvent(eventName, params);

  if (!window.gtag) return;

  window.gtag('event', eventName, params);
};
